import { render } from "./RebateTab.vue?vue&type=template&id=27198144"
import script from "./RebateTab.vue?vue&type=script&lang=js"
export * from "./RebateTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__